import type { ConfiguredFieldOptions } from '@cims-online/shared'
import { useOptions } from 'components/CIMSSelect/hooks/useOptions'

/** Uses standard option tooltips while retaining selected deleted choices. */
export function useConfiguredOptions(
  field: Extract<
    ConfiguredFieldOptions,
    { type: 'approvals' | 'select' | 'selected_by' }
  >,
  selectedOptionIds: readonly string[]
) {
  const selectedIds = new Set(selectedOptionIds)
  return useOptions({
    items: [...field.options],
    sort: false,
    value: 'id',
    label: 'label',
    tooltip: 'tooltip',
    deleted: ({ deleted }) => deleted,
    disabled: ({ deleted, id }) => deleted && !selectedIds.has(id),
  })
}
